import { useQuery } from '@tanstack/react-query';
import { eventService } from '../services/eventService';

/** 대회의 생년월일·성별 수집 여부. 응답 데이터에 남아있는 값과 무관하게, 미수집 항목의 필터를 전체로 고정하는 데 쓴다. */
export function useEventCollectFlagsQuery(eventId: number | null) {
  return useQuery({
    queryKey: ['event-collect-flags', eventId],
    queryFn: () => eventService.detail(eventId ?? 0),
    enabled: eventId != null,
    select: (event) => ({ collectBirth: event.collectBirth, collectGender: event.collectGender }),
  });
}
